<template>
  <v-row
      align="center"
      justify="center"
    >
    <v-col
      cols="3"
      md="2"
    >
      <v-img :src="item.reference.thumbnail"></v-img>
    </v-col>
    <v-col
      cols="9"
      md="4"
    >
      Référence {{ item.reference.name }}<br>
      Couleur : <span class="mini-chip" :style="'background-color: ' + item.color.hexacode"></span> {{ item.color.name }}<br>
      Taille : {{ item.size.name }}
    </v-col>
    <v-col
      cols="3"
      md="3"
      class="text-center"
    >
      {{ item.getUnitPrice() | toPrice(2, '€ HT') }}
    </v-col>
    <v-col
      cols="9"
      md="3"
    >
      <v-row
        display="flex"
        justify="center"
        align="center"
      >
        <v-btn 
          fab 
          x-small 
          dark 
          color="primary"
          @click.stop="rmvQty"
        >
          <v-icon>mdi-minus</v-icon>
        </v-btn>
        <v-text-field
          dense
          type="number"
          class="pt-2 mb-0 flex-shrink-3"
          style="width: 60px"
          v-model="quantity"
          min=0
          @input="changeQty"
        ></v-text-field>
        <v-btn 
          fab 
          x-small 
          dark 
          color="primary"
          @click.stop="addQty"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-row>
    </v-col>

    <v-col cols="12">
      <v-divider></v-divider>
    </v-col>
  </v-row>
</template>

<script>
  // EVENTS
  import { CHANGE_ITM_QTY, OPEN_DIALOG } from '@/store/actions/cart'

  export default {
    name: 'Item',

    data: function () {
      return {
        quantity: this.item.quantity
      }
    },

    props: {
      item: Object,
    },

    methods: {
      changeQty() {
        this.$store.dispatch(CHANGE_ITM_QTY, {
          id: this.item.id, 
          qty: this.quantity
        })
      },
      rmvQty() {
        if (this.quantity > 1) {
          this.quantity--
          this.changeQty()
        } else {
          this.$emit(OPEN_DIALOG, this.item)
        }
      },
      addQty() {
        this.quantity++
        this.changeQty()
      }
    },
  }
</script>

<style scoped>
  .mini-chip {
    display: inline-block;
    width: 12px;
    height: 12px;
    border: 1px solid #000;
    border-radius: 50%;
    margin-right: 5px;
    cursor: pointer;
    align-items: center;
    display: inline-flex;
    font-feature-settings: "liga";
    font-size: 24px;
    justify-content: center;
    letter-spacing: normal;
    line-height: 1;
    position: relative;
    text-indent: 0;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), visibility 0s;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .v-text-field {
    flex: 0 1 auto;
    margin-left: 20px;
    margin-right: 20px;
  }
</style>